export default {
  all: [
    {
      name: 'West Coast Customs',
      status: 'Active',
      id: 1
    },
    {
      name: 'Allgood Automotive',
      status: 'Active',
      id: 2
    },
    {
      name: 'American Choppers',
      status: 'Active',
      id: 3
    }
  ]
}
